/**
 * S03 — ACT I: THE MUSCLE (The Luca Brasi Phase)
 *
 * Full-bleed HF#1 cold open MP4 sequence as hero background, with
 * blood-red overlay wash and the Act I story rendered on top. Uses
 * the shared ActSection primitive.
 */

import { ActSection } from "./ActSection";
import { sectionCopy, actStories } from "@/lib/voice";
import videoSrc from "@/assets/higgsfield/hf-01-cold-open-sequence.mp4";
import posterSrc from "@/assets/higgsfield/hf-02-meyhem-backroom.webp";

export function S03_ActOne() {
  const copy = sectionCopy.s03;
  return (
    <ActSection
      sectionId="s03"
      meta={copy.meta}
      monument={copy.monument}
      act={actStories.act1}
      videoSrc={videoSrc}
      videoPoster={posterSrc}
      spotColor="blood"
      bgFilter="contrast(1.15) brightness(0.5) saturate(0.75)"
      overlayGradient="radial-gradient(ellipse at center, rgba(5,5,5,0.35) 0%, rgba(5,5,5,0.88) 100%)"
    />
  );
}
